export default {
  'home.announcement': 'Niezależne źródło informacji — niepowiązane z USFans ani przez niego niewspierane.',
  'home.heroTitle': 'Mądrzejszy sposób na poznanie USFans Spreadsheet',
  'home.heroSub': 'Odkrywaj przydatne znaleziska, porównuj kategorie, rozumiej kontrolę jakości (QC), sprawdzaj szczegóły wysyłki i ucz się, jak badać produkty przed złożeniem zamówienia.',
  'home.primaryCta': 'USFans Spreadsheet',
  'home.secondaryCta': 'Przeczytaj poradnik',
  'home.trustLine': 'Niezależne badania · Aktualizowane poradniki · Informacje o bezpieczeństwie',

  'home.categoriesTitle': 'Przeglądaj kategorie USFans Spreadsheet',
  'home.categoriesSub': 'Przejdź od razu do kategorii i przeglądaj najnowsze znaleziska na stronie głównej.',
  'home.categoryDropdownLabel': 'Wybierz kategorię',

  'home.whatTitle': 'Czym jest USFans Spreadsheet?',
  'home.whatP1': 'USFans Spreadsheet to wspólne źródło informacji, które wiele osób wykorzystuje do porządkowania linków do produktów, kategorii, notatek o sprzedawcach, szczegółów QC i referencji zakupowych w jednym miejscu. Zamiast przeglądać rozproszone strony, użytkownicy korzystają z arkusza, aby sprawniej przeglądać produkty i porównywać opcje przed podjęciem decyzji.',
  'home.whatP2': 'Ważne jest, aby jasno powiedzieć, czym arkusz nie jest. Nie jest oficjalnym marketplace i nie jest prowadzony przez samą markę. Myśl o nim jak o katalogu i systemie notatek tworzonych przez społeczność: jego wartość wynika z tego, jak informacje są zbierane, porządkowane i aktualizowane, a nie z obietnicy jednego sprzedawcy.',
  'home.whatP3': 'Typowy arkusz jest podzielony na kategorie — buty, bluzy, koszulki, kurtki, spodnie, koszulki sportowe, akcesoria i więcej — z kolumnami na nazwy produktów, linki, rozmiary, referencje sprzedawców, notatki QC i szczegóły wysyłki. Niektóre wersje zawierają też informacje o magazynie i wskazówki, jak czytać zdjęcia QC.',
  'home.whatNotice': 'Niezależne oświadczenie',
  'home.whatNoticeText': 'Ta strona jest niezależnym źródłem informacji. Nie jest oficjalnie powiązana z USFans ani przez niego wspierana, chyba że zostało to wyraźnie zaznaczone.',

  'home.benefitsTitle': 'Dlaczego warto zacząć od arkusza?',
  'home.benefitsSub': 'Dobrze zorganizowany arkusz zamienia rozproszone badanie w jasny, powtarzalny proces.',
  'home.benefit1Title': 'Odkrywaj szybciej',
  'home.benefit1Desc': 'Znajduj istotne zasoby produktowe bez przeglądania rozproszonych stron.',
  'home.benefit2Title': 'Porównuj lepiej',
  'home.benefit2Desc': 'Porównuj kategorie, informacje o produktach i notatki obok siebie.',
  'home.benefit3Title': 'Sprawdzaj QC uważnie',
  'home.benefit3Desc': 'Zrozum, na co patrzeć przed wysyłką międzynarodową.',
  'home.benefit4Title': 'Badaj z pewnością',
  'home.benefit4Desc': 'Poznaj procesy wysyłki, magazynu, bezpieczeństwo i typowe błędy.',
  'home.benefitCta': 'Przeglądaj USFans Spreadsheet',

  'home.checklistTitle': 'Lista kontrolna badania USFans Spreadsheet',
  'home.checklistSub': 'Szybki podgląd tego, co sprawdzić przed kolejnym krokiem.',
  'home.checkArea': 'Obszar badania',
  'home.checkWhat': 'Co sprawdzić',
  'home.checkWhy': 'Dlaczego to ważne',
  'home.check.r1.area': 'Produkt',
  'home.check.r1.what': 'Cena, sprzedawca, kategoria',
  'home.check.r1.why': 'Unikaj złych wyborów',
  'home.check.r2.area': 'QC',
  'home.check.r2.what': 'Zdjęcia, szczegóły, wady',
  'home.check.r2.why': 'Wcześnie wykryj problemy',
  'home.check.r3.area': 'Magazyn',
  'home.check.r3.what': 'Przechowywanie, inspekcja',
  'home.check.r3.why': 'Zrozum status zamówienia',
  'home.check.r4.area': 'Wysyłka',
  'home.check.r4.what': 'Waga, objętość, trasa',
  'home.check.r4.why': 'Oszacuj całkowity koszt',
  'home.check.r5.area': 'Sprzedawca',
  'home.check.r5.what': 'Historia, opinie',
  'home.check.r5.why': 'Zmniejsz niepewność',
  'home.check.r6.area': 'Bezpieczeństwo',
  'home.check.r6.what': 'Linki, płatność, prywatność',
  'home.check.r6.why': 'Unikaj podejrzanych działań',

  'home.guidesTitle': 'Badaj USFans z pewnością',
  'home.guidesSub': 'Zacznij od naszych poradników, a potem poznaj tematy, które Cię interesują.',
  'home.guide.review.title': 'Recenzja USFans',
  'home.guide.review.desc': 'Zrozum platformę, przepływ pracy, mocne strony i potencjalne ryzyka.',
  'home.guide.shipping.title': 'Koszt wysyłki',
  'home.guide.shipping.desc': 'Dowiedz się, co wpływa na koszty wysyłki międzynarodowej.',
  'home.guide.safety.title': 'Poradnik bezpieczeństwa',
  'home.guide.safety.desc': 'Zrozum typowe ryzyka i bezpieczniejsze praktyki badania.',
  'home.guide.article.title': 'Kompletny poradnik dla początkujących',
  'home.guide.article.desc': 'Nasz autorski, szczegółowy przewodnik po USFans Spreadsheet.',

  'home.faqTitle': 'FAQ — USFans Spreadsheet',
  'home.faqSub': 'Odpowiedzi na najczęściej zadawane pytania.',
  'home.faq.q1': 'Czym jest USFans Spreadsheet?',
  'home.faq.a1': 'To wspólne źródło informacji do porządkowania linków do produktów, kategorii, notatek o sprzedawcach, szczegółów QC i referencji zakupowych w jednym miejscu.',
  'home.faq.q2': 'Jak korzystać z USFans Spreadsheet?',
  'home.faq.a2': 'Przeglądaj według kategorii, sprawdzaj notatki o produktach i QC, porównuj opcje i korzystaj z linków, aby kontynuować badanie przed złożeniem zamówienia.',
  'home.faq.q3': 'Czy USFans jest legalny?',
  'home.faq.a3': 'Zachowujemy neutralne stanowisko. Sprawdź historię sprzedawcy, przeczytaj opinie i zweryfikuj linki oraz strony płatności, zanim zaufasz jakiemukolwiek twierdzeniu.',
  'home.faq.q4': 'Czy USFans jest bezpieczny?',
  'home.faq.a4': 'Bezpieczeństwo zależy od tego, jak starannie badasz. Unikaj udostępniania haseł i poufnych danych oraz weryfikuj każdy link przed kliknięciem.',
  'home.faq.q5': 'Ile kosztuje wysyłka USFans?',
  'home.faq.a5': 'Koszty zależą od wagi, objętości, trasy i miejsca docelowego. Korzystaj z szacunków, a nie stałych cen, i potwierdzaj przed zamówieniem.',
  'home.faq.q6': 'Czy USFans ma kupony?',
  'home.faq.a6': 'Oferty często się zmieniają. Zawsze sprawdzaj aktualną oficjalną ofertę przed użyciem kuponu lub kodu rabatowego.',
  'home.faq.q7': 'Czym jest magazyn USFans?',
  'home.faq.a7': 'Odnosi się do usług przechowywania i inspekcji, które mogą być używane do przetrzymywania, sprawdzania i konsolidacji przedmiotów przed wysyłką.',
  'home.faq.q8': 'Jak działa QC w USFans?',
  'home.faq.a8': 'Zdjęcia i notatki QC pomagają wykryć wady, złe rozmiary lub uszkodzone przedmioty, zanim zostaną wysłane międzynarodowo.',

  'home.finalTitle': 'Gotowy na poznanie USFans Spreadsheet?',
  'home.finalText': 'Skorzystaj z naszych poradników, porównań i zasobów badawczych, aby ułatwić sobie cały proces, zrozumieć ryzyka i znaleźć potrzebne informacje przed kolejnym krokiem.',
  'home.finalCta': 'Kup teraz',
  'home.finalSecondary': 'USFans Spreadsheet',

  'home.articlesTitle': 'Najnowsze poradniki i artykuły USFans',
  'home.articlesSub': 'Szczegółowe, oryginalne artykuły, które pomogą Ci mądrzej prowadzić research.',
};